import axios, { type AxiosResponse } from 'axios'

export type Icon = {
	id: string
	label: string
	familyStylesByLicense: { pro: { prefix: string }[] | null } | null
}

export interface FontAwesomeSearchResponse {
	data: {
		search: Icon[] | null
	} | null
	errors?: { message: string }[]
}

export default class FontAwesomeApi {
	requestController = new AbortController()

	async search(
		searchString: string,
	): Promise<AxiosResponse<FontAwesomeSearchResponse> | undefined> {
		this.requestController.abort()
		this.requestController = new AbortController()
		const query = `query SearchIcons($query: String!) { search(version: "7.1.0", query: $query, first: 100) { id, label, familyStylesByLicense { pro { prefix } } } }`
		try {
			const res = await axios.post<FontAwesomeSearchResponse>(
				'https://api.fontawesome.com',
				{
					query,
					variables: { query: searchString },
				},
				{
					withCredentials: false,
					withXSRFToken: false,
					signal: this.requestController.signal,
				},
			)
			if (res.data.errors?.length || !Array.isArray(res.data.data?.search)) {
				throw new Error(
					res.data.errors?.map((error) => error.message).join(', ') ||
						'Font Awesome returned invalid search results',
				)
			}
			return res
		} catch (e: unknown) {
			if (axios.isCancel(e)) {
				return undefined
			}
			throw e
		}
	}
}
